/* lua.js generated code 0.3.0 */
var QzoneBackgroundPanel = require("clover/panel/QzoneBackgroundPanel")
let HomeSceneBtn = require("clover/scene/component/homescene/HomeSceneButton")
var QzoneBackgroundButton = xClass("QzoneBackgroundButton", HomeSceneBtn)
QzoneBackgroundButton.prototype.ctor = function () {
    let self = this
    let image = "cocos/qzone_background_icon.png"
    let text = "空间背景"
    HomeSceneBtn.prototype.ctor.call(self, text, image)
}
// QzoneBackgroundButton.prototype.init = function () {
//     var self = this
//     self.on(UIButtonEvent.Click, handler(self, self.onClicked))
//     self.nodeExist = true
//     var arr = self.getChildByName("new")
//     arr.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.EaseSineIn.create(cc.MoveBy.create(0.3, cc.p(0, 3))), cc.EaseSineOut.create(cc.MoveBy.create(0.3, cc.p(0, -3))))))
//     arr.setVisible(false)
//     var action = cc.CSLoader.createTimeline("cocos/homeScene_glowanime.csb")
//     self.getChildByName("glow").runAction(action)
//     action.gotoFrameAndPlay(0, true)
//     self.getChildByName("glow").setVisible(false)
//     var $st7 = self.getChildByName("glow").getChildren()
//     for (let i = 1, v = $st7[1]; v; i++, v = $st7[i]) {
//     if (v.getName() !== "glow") {
//             v.setBlendFunc(table([1, "src", gl.SRC_ALPHA], [1, "dst", gl.ONE]))
//         }
//     }

//     let btna = self.getChildByName("icon")
//     btna.setScale(1.3)
//     btna.setPositionY(btna.getPositionY() + 10)

//     // 使用系统字体代替
//     // 之后直接改csb
//     var text = self.getChildByName("text")
//     text.removeFromParent(true)
//     text = cc.LabelTTF.create('空间背景', FONT_DEF.microsoftYahei_24_blueStroke)
//     self.addChild(text)
//     text.y = -32

//     // [0, table([1, "class", UserRank], [1, "event", UserRankEvent.FriendRank])],
//     // [0, table([1, "class", UserRank], [1, "event", UserRankEvent.RankExtraInfo])],
// }
// QzoneBackgroundButton.prototype.init = function () {
//     var self = this
//     self.on(UIButtonEvent.Click, handler(self, self.onClicked))
//     self.nodeExist = true
//     var arr = self.getChildByName("new")
//     arr.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.EaseSineIn.create(cc.MoveBy.create(0.3, cc.p(0, 3))), cc.EaseSineOut.create(cc.MoveBy.create(0.3, cc.p(0, -3))))))
//     arr.setVisible(false)
//     var action = cc.CSLoader.createTimeline("cocos/homeScene_glowanime.csb")
//     self.getChildByName("glow").runAction(action)
//     action.gotoFrameAndPlay(0, true)
//     self.getChildByName("glow").setVisible(false)
//     var $st7 = self.getChildByName("glow").getChildren()
//     for (let i = 1, v = $st7[1]; v; i++, v = $st7[i]) {
//     if (v.getName() !== "glow") {
//             v.setBlendFunc(table([1, "src", gl.SRC_ALPHA], [1, "dst", gl.ONE]))
//         }
//     }

//     let btna = self.getChildByName("icon")
//     btna.setScale(1.3)
//     btna.setPositionY(btna.getPositionY() + 10)

//     // 使用系统字体代替
//     // 之后直接改csb
//     var text = self.getChildByName("text")
//     text.removeFromParent(true)
//     text = cc.LabelTTF.create('空间背景', FONT_DEF.microsoftYahei_24_blueStroke)
//     self.addChild(text)
//     text.y = -32

//     // [0, table([1, "class", UserRank], [1, "event", UserRankEvent.FriendRank])],
//     // [0, table([1, "class", UserRank], [1, "event", UserRankEvent.RankExtraInfo])],
// }
QzoneBackgroundButton.prototype.customInit = function () {
    var self = this
    self.imageNode.setScale(0.8, 0.8)
    self.imageNode.setPositionX(15)
    self.text.setPositionY(-45)
    self.imageNode.setPositionY(self.imageNode.getPositionY() + 15)
    self.setContentSize(100, 120)
    // self.rewardIcon = cc.Sprite.createWithSpriteFrameName("reddot/reddot.png")
    self.rewardIcon = cc.Sprite.createWithSpriteFrameName("h5library/reddot.png")
    // self.rewardIcon.setScale(0.15)
    self.rewardIcon.setPosition(35, 30)
    // self.rewardIcon.setPosition(27, 30)
    self.addChild(self.rewardIcon)
}
QzoneBackgroundButton.prototype.onCick = function () {
    // Toast.make("空间背景暂时未开放！")
    // self.setEnabled(false)
    // StarRankPanelLogic.create().start(false, function () {
    //     if (self.nodeExist) {
    //         self.setEnabled(true)
    //         self.getChildByName("new").setVisible(false)
    //         self.getChildByName("glow").setVisible(false)
    //     }
    // })
    var self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    DCAssist.userTrack("cover", "click_icon");
    var panel = QzoneBackgroundPanel.asyncCreate(function () {
        self.isBusy = false
    }, function(){
        Toast.make("网络出了点问题啦~", 2, function () {
            self.isBusy = false
        })
    }, function () {
        self.isBusy = false
    })
}
module.exports = QzoneBackgroundButton
